import * as React from 'react';
export const seicomartSvg = React.forwardRef(function seicomartSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.83 4.746C1.34 5.738 1 7.07 1 7.996c0 1.496.756 3.508 1.748 4.649.647.745 2 1.662 2.963 2.008.944.34 2.935.456 3.949.23.75-.166 1.8-.6 2.209-.912.227-.173.187-.18-.44-.063-.88.161-3.41.046-4.147-.19-1.053-.337-1.79-.753-2.51-1.419-1.328-1.223-1.711-2.696-1.395-5.356.167-1.39.13-1.586-.401-2.166l-.252-.276.303-.076c.166-.041.555-.017.865.054.337.075.681.119 1.026.131l.466.004-.326.627c-.41.787-.444 1.781-.081 2.399.481.82 1.45 1.194 2.207.85.515-.235.879-.945 1.18-2.309.528-2.382 1.234-3.243 3.318-4.05.301-.116.285-.135-.42-.462-.447-.204-.91-.375-1.382-.512C9.065.94 7.04.95 6.222 1.173c-1.83.5-3.576 1.92-4.392 3.573ZM12.8 3.174c-.16.369-.201 1.451-.117 3.074.084 1.627-.652 2.814-2.06 3.322-.204.074-.395.208-.426.3-.044.13.131.152.84.102 1.195-.085 1.71-.423 2.272-1.491.562-1.068.953-1.575 1.388-1.799.343-.176.355-.21.232-.657-.194-.715-.924-2.032-1.475-2.664l-.492-.563-.162.376ZM3.696 4.745c-.12.194.044.317.206.156.09-.09.092-.16.007-.212a.158.158 0 0 0-.213.056Zm7.484 7.148c-.31-.07-.612-.081-.668-.025-.15.15.728.827 1.288.995 1.183.352 1.688.057 2.502-1.464.416-.777.406-1.034-.016-.455-.52.712-2.064 1.184-3.106.949Z',
    }),
  );
});
seicomartSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var seicomart = {
  category: 'paymentmethod',
  colorable: true,
  name: 'seicomart',
  svg: seicomartSvg,
};
